/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { shape, bool, arrayOf } from "prop-types";
import { TagGroup } from "@ui-kit/components/index.es";
import { selectors as transactionsSelectors } from "reducers/transactions";
import MultipleSignaturesBody from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesBody";
import { MultipleSignaturesDataProvider } from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesDataContext";
import { isMvp5PendingTransactionsEnabled } from "util/transaction";
import { getActivityLabel } from "util/multipleSignaturesProcessingSummary";
import { getTransferActivityName } from "util/transferInternalTitleLabels";

const groupRowsByFirstAppearanceIdActivity = (rows) => {
    if (!rows?.length) {
        return [];
    }
    const byId = new Map();
    const order = [];
    rows.forEach((row) => {
        const idActivity = row.transaction?.idActivity;
        if (!byId.has(idActivity)) {
            byId.set(idActivity, []);
            order.push(idActivity);
        }
        byId.get(idActivity).push(row);
    });
    return order.map((idActivity) => ({ idActivity, rows: byId.get(idActivity) }));
};

const toSentenceCase = (value) => {
    const s = String(value || "").trim();
    if (!s) {
        return "";
    }
    return s.charAt(0).toLocaleUpperCase("es") + s.slice(1).toLocaleLowerCase("es");
};

class MultipleSignaturesDataTables extends Component {
    static propTypes = {
        multipleSignaturesData: shape({}).isRequired,
        isDesktop: bool.isRequired,
        activities: arrayOf(shape({})),
    };

    static defaultProps = {
        activities: null,
    };

    hasMixedActivities = () => {
        const { multipleSignaturesData } = this.props;
        if (!multipleSignaturesData?.activitySelected) {
            return true;
        }
        const { selectedTransactionRows } = multipleSignaturesData || {};
        if (!selectedTransactionRows || selectedTransactionRows.length <= 1) {
            return false;
        }
        const idActivities = new Set(selectedTransactionRows.map((r) => r.transaction?.idActivity));
        return idActivities.size > 1;
    };

    selectDataTable = () => {
        const { multipleSignaturesData, isDesktop } = this.props;

        const returnContent = MultipleSignaturesBody?.[multipleSignaturesData?.activitySelected?.idActivity];

        return returnContent ? returnContent(isDesktop) : "";
    };

    renderRowCard = (row, index, multipleSignaturesData, isDesktop, activities) => {
        const idActivity = row.transaction?.idActivity;
        const BodyFactory = MultipleSignaturesBody?.[idActivity];
        if (!BodyFactory) {
            return null;
        }

        const catalogActivity = activities?.find((a) => a.idActivity === idActivity);
        const completeActivity = catalogActivity
            ? {
                  ...catalogActivity,
                  activityName: getTransferActivityName(idActivity, catalogActivity.activityName),
              }
            : {
                  idActivity,
                  activityName: getTransferActivityName(idActivity, row.transaction?.activityName) || idActivity,
              };
        const scopedData = {
            ...multipleSignaturesData,
            selectedTransactionRows: [row],
            activitySelected: completeActivity,
        };

        const content = BodyFactory(isDesktop);
        return (
            <MultipleSignaturesDataProvider key={row.transaction?.idTransaction || index} value={scopedData}>
                {content}
            </MultipleSignaturesDataProvider>
        );
    };

    renderCombinedCards = () => {
        const { multipleSignaturesData, isDesktop, activities } = this.props;
        const { selectedTransactionRows } = multipleSignaturesData || {};
        if (!selectedTransactionRows?.length) {
            return null;
        }

        if (!isMvp5PendingTransactionsEnabled()) {
            return selectedTransactionRows.map((row, index) =>
                this.renderRowCard(row, index, multipleSignaturesData, isDesktop, activities),
            );
        }

        const groups = groupRowsByFirstAppearanceIdActivity(selectedTransactionRows);
        return groups.map((group) => {
            const firstRow = group.rows[0];
            const fromCatalog = activities?.find((a) => a.idActivity === group.idActivity);
            const rawLabel =
                getActivityLabel(firstRow) ||
                (fromCatalog?.activityName &&
                    String(getTransferActivityName(group.idActivity, fromCatalog.activityName)).trim()) ||
                group.idActivity;
            const groupLabel = toSentenceCase(rawLabel);

            return (
                <div
                    key={group.idActivity}
                    className={classNames("multiple-signatures-mvp5-group w-100", isDesktop ? "mb-3" : "mb-2")}>
                    <TagGroup
                        groupLabel={groupLabel}
                        variant="dark"
                        className="multiple-signatures-mvp5-group__label"
                        ml={12}
                        {...(isDesktop ? {} : { justify: "start" })}>
                        <div className="multiple-signatures-mvp5-group__cards">
                            {group.rows.map((row, index) =>
                                this.renderRowCard(row, index, multipleSignaturesData, isDesktop, activities),
                            )}
                        </div>
                    </TagGroup>
                </div>
            );
        });
    };

    render() {
        const { isDesktop } = this.props;

        if (this.hasMixedActivities()) {
            const combinedContent = this.renderCombinedCards();
            return isDesktop ? <div className="mb-4 w-100">{combinedContent}</div> : combinedContent;
        }

        const content = this.selectDataTable();
        return isDesktop ? <div className="mb-4 w-100">{content}</div> : content;
    }
}
const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
    activities: transactionsSelectors.getActivities(state),
});

export default connect(mapStateToProps)(MultipleSignaturesDataTables);
